import React from "react";
// import StaffIcon from "../../../assets/images/employee.png";
import StaffIcon from "../../../assets/icons/teacher.png";

import SavingsIcon from "../../../assets/images/piggy.png";
import InvestmentsIcon from "../../../assets/images/investment.png";

import LoansIcon from "../../../assets/images/loans.png";

// import TripIcon from "../../../assets/images/destination.png";
import TripIcon from "../../../assets/icons/trip-icon.png";

// import StudentIcon from "../../../assets/images/students.png";
import StudentIcon from "../../../assets/icons/student.png";

function ImagIcon(props) {
  const { display } = props;
  let Icon;
  switch (display) {
    case "Savings":
      Icon = SavingsIcon;
      break;
    case "Investments":
      Icon = InvestmentsIcon;
      break;
    case "Loans":
      Icon = LoansIcon;
      break;
    default:
      Icon = SavingsIcon;
  }
  return (
    <div className="ovv-imageIcons-container">
      <img
        className="ovv-imageIcon"
        width="40"
        height="40"
        src={Icon}
        alt="Top Statistics Logo"
      />
    </div>
  );
}

export default ImagIcon;
